var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7701 31.9181C64.0912 32.136 55.9557 26.2349 50.3282 26.3413C44.7007 26.4477 32.939 29.9049 33.4237 55.7961C33.9084 81.6873 49.8806 85.1901 56.0722 85.0753C85.0592 84.5331 96.4561 31.5313 75.7701 31.9181Z",
    fill: "url(#paint0_linear_390_4053)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2979 35.3633H86.6757V37.0522H83.2979V35.3633Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.585 35.3633H76.9628V37.0522H73.585V35.3633Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4961 29.4531H81.185V32.831H79.4961V29.4531Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4961 39.1641H81.185V42.5419H79.4961V39.1641Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8742 77.5853C29.4775 77.5853 28.3408 76.4487 28.3408 75.0519C28.3408 73.6552 29.4775 72.5186 30.8742 72.5186C32.2709 72.5186 33.4076 73.6552 33.4076 75.0519C33.4076 76.4487 32.2709 77.5853 30.8742 77.5853ZM30.8742 74.2075C30.4081 74.2075 30.0297 74.5875 30.0297 75.0519C30.0297 75.5164 30.4081 75.8964 30.8742 75.8964C31.3403 75.8964 31.7187 75.5164 31.7187 75.0519C31.7187 74.5875 31.3403 74.2075 30.8742 74.2075Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5228 56.662H73.6078L78.0541 37.6053C78.2287 36.8571 77.7594 36.11 77.0059 35.9366C76.2528 35.7632 75.5002 36.2293 75.3255 36.9775L70.7326 56.662H43.3116L38.7189 36.9776C38.5443 36.2294 37.792 35.7633 37.0384 35.9367C36.285 36.1101 35.8157 36.8571 35.9903 37.6054L40.4366 56.6621H34.5215C33.7481 56.6621 33.1211 57.2848 33.1211 58.0528V72.1235C33.1211 72.8915 33.7481 73.5142 34.5215 73.5142H38.8223V74.6019C38.8223 75.3699 39.4494 75.9926 40.2228 75.9926C40.9962 75.9926 41.6233 75.3699 41.6233 74.6019V73.5142H72.421V74.6019C72.421 75.3699 73.0481 75.9926 73.8215 75.9926C74.5949 75.9926 75.2219 75.3699 75.2219 74.6019V73.5142H79.5228C80.2963 73.5142 80.9233 72.8915 80.9233 72.1235V58.0527C80.9233 57.2847 80.2963 56.662 79.5228 56.662ZM78.1224 70.7327H35.922V59.4434H78.1224V70.7327Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3321 66.4786H52.2476C53.0211 66.4786 53.6481 65.856 53.6481 65.0879C53.6481 64.3199 53.0211 63.6973 52.2476 63.6973H40.3321C39.5587 63.6973 38.9316 64.3199 38.9316 65.0879C38.9316 65.856 39.5587 66.4786 40.3321 66.4786Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7813 66.4786H65.5041C66.2775 66.4786 66.9045 65.856 66.9045 65.0879C66.9045 64.3199 66.2775 63.6973 65.5041 63.6973H62.7813C62.0079 63.6973 61.3809 64.3199 61.3809 65.0879C61.3809 65.856 62.0079 66.4786 62.7813 66.4786Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9903 66.4786H73.7131C74.4865 66.4786 75.1135 65.856 75.1135 65.0879C75.1135 64.3199 74.4865 63.6973 73.7131 63.6973H70.9903C70.2169 63.6973 69.5898 64.3199 69.5898 65.0879C69.5898 65.856 70.2169 66.4786 70.9903 66.4786Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9854 50.9828C51.4385 51.5259 51.4385 52.4064 51.9854 52.9495C52.5322 53.4926 53.419 53.4926 53.9659 52.9495C55.6516 51.2757 58.3942 51.2757 60.0798 52.9495C60.3533 53.2211 60.7117 53.3569 61.07 53.3569C61.4284 53.3569 61.7869 53.2212 62.0603 52.9495C62.6072 52.4064 62.6072 51.5259 62.0603 50.9828C59.2828 48.2245 54.763 48.2245 51.9854 50.9828Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0272 49.4288C65.3856 49.4288 65.744 49.293 66.0174 49.0214C66.5643 48.4783 66.5643 47.5978 66.0174 47.0547C61.0584 42.1302 52.9893 42.1302 48.0303 47.0547C47.4834 47.5978 47.4834 48.4783 48.0303 49.0214C48.5771 49.5645 49.4639 49.5645 50.0108 49.0214C53.8779 45.1814 60.1699 45.1814 64.0369 49.0214C64.3103 49.293 64.6687 49.4288 65.0272 49.4288Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6289 44.6681C51.9128 38.4281 62.1374 38.4281 68.4213 44.6681C68.6948 44.9396 69.0532 45.0755 69.4115 45.0755C69.7699 45.0755 70.1284 44.9397 70.4017 44.6681C70.9487 44.125 70.9487 43.2445 70.4017 42.7014C66.8288 39.1532 62.0783 37.1992 57.0252 37.1992C51.972 37.1992 47.2215 39.1532 43.6485 42.7014C43.1016 43.2445 43.1016 44.125 43.6485 44.6681C44.1953 45.2112 45.0821 45.2112 45.6289 44.6681Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4053",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4053",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4053",
    x1: 59.8652,
    y1: 26.3398,
    x2: 59.8652,
    y2: 85.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk12);
export default __webpack_public_path__ + "static/media/uwalk12.843dcb3f9649983ee86be7d4f100cd10.svg";
export { ForwardRef as ReactComponent };